import { render, staticRenderFns } from "./layereddialog.vue?vue&type=template&id=0df7837c&"
import script from "./../../ts/dialog/layereddialog.ts?vue&type=script&lang=js&"
export * from "./../../ts/dialog/layereddialog.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/dialog/layereddialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports